import { SyncableSingle } from 'shared/state/models/syncable';
import { IDashboardSettings } from 'shared/api/api';

export const SAVE_DROPDOWN_SCROLL_OPTION = 'SAVE_DROPDOWN_OPTION';
export const SYNC_DATA_DASHBOARDSETTINGS = 'SYNC_DATA_DASHBOARDSETTINGS';
export const SAVE_DASHBOARDSETTINGS = 'SAVE_DASHBOARDSETTINGS';
export const RESET_DROPDOWN_SCROLL_OPTIONS = 'RESET_DROPDOWN_SCROLL_OPTIONS';
export interface DashboardSettingsState extends SyncableSingle<IDashboardSettings> {}
